const SRC_URL = () => {
  switch (process.env.VUE_APP_ENV_NAME) {
    case "develop":
      return {
        riskApi: "http://prlegw.dev-newsports.com",
      };
    case "testing":
      return {
        riskApi: "http://prlegw.test-newsports.com",
      };
    case "pre":
      return {
        riskApi: "https://prlegw.server.newsportspro.com",
      };
    case "staging":
      return {
        riskApi: "https://prlegw.server.st-newsports.com",
      };
    default:
      return {
        riskApi: "http://prlegw.test-newsports.com",
      };
  }
};

export default SRC_URL();
